export const MIDTRANS_ASPHALT_THEME = {
  "--background-fill-brand": "hsla(193, 100%, 43%, 1)",
  "--text-brand": "hsla(193, 100%, 43%, 1)",
  "--icon-brand": "hsla(193, 100%, 43%, 1)",
  "--interactive-fill-brand-default": "hsla(209, 98%, 33%, 1)",
  "--interactive-fill-brand-hover": "hsla(209, 88%, 80%, 1)",
  "--interactive-fill-brand-active": "hsla(209, 98%, 33%, 1)",
  "--interactive-fill-selected-default": "hsla(209, 98%, 33%, 1)",
  "--interactive-fill-selected-active": "hsla(209, 98%, 33%, 1)",
  "--interactive-fill-selected-hover": "hsla(209, 98%, 33%, 1)",
  "--checkbox-border-color-active": "hsla(209, 98%, 33%, 1)",
  "--checkbox-background-color-active": "hsla(209, 98%, 33%, 1)",
  "--button-primary-fill-color": "hsla(209, 98%, 33%, 1)",
  "--button-primary-active-color": "hsla(209, 98%, 33%, 1)",
  "--button-border-focus": "hsla(209, 98%, 33%, 1)",
  "--button-outline-font": "hsla(209, 98%, 33%, 1)",
};
